import client from 'api/client';
import { AxiosRequestConfig } from 'axios';
import { ServiceProviderListPayload } from '../models/payload';

export function post(payload: ServiceProviderListPayload, customConfig?: AxiosRequestConfig) {
    return client.post('/service_providers', payload, customConfig);
}
